export const IdSmallIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    fill="none"
    viewBox="0 0 25 25"
    {...props}>
    <path
      stroke="#455A64"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="1.5"
      d="M2.836 8.791h11"></path>
    <path
      stroke="#455A64"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="1.2"
      d="M6.836 16.791h2M11.336 16.791h4"></path>
    <path
      stroke="#455A64"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.2"
      d="M22.836 11.621v4.78c0 3.51-.89 4.39-4.44 4.39H7.276c-3.55 0-4.44-.88-4.44-4.39v-8.22c0-3.51.89-4.39 4.44-4.39h6.84"></path>
    <path
      stroke="#455A64"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="1.2"
      d="M17.836 3.541h3.13c.69 0 1.25.63 1.25 1.25 0 .69-.56 1.25-1.25 1.25h-3.13v-2.5zM17.836 6.041h3.57c.79 0 1.43.56 1.43 1.25s-.64 1.25-1.43 1.25h-3.57v-2.5zM19.596 8.541v1.25M19.596 2.291v1.25M19.026 3.541h-2.19M19.026 8.541h-2.19"></path>
  </svg>
);
